.base {
	display: inline-block;
	vertical-align: middle;
	flex: none;
}

.default {
	fill: var(--lp-color-fill-ui-primary);
}

.subtle {
	fill: var(--lp-color-fill-ui-secondary);
}

.tiny {
	width: var(--lp-size-12);
	height: var(--lp-size-12);
}

.small {
	width: var(--lp-size-16);
	height: var(--lp-size-16);
}

.medium {
	width: var(--lp-size-20);
	height: var(--lp-size-20);
}

.large {
	width: var(--lp-size-40);
	height: var(--lp-size-40);
}
